import { render, staticRenderFns } from "./payStatus.vue?vue&type=template&id=d1c5ecda&scoped=true&"
import script from "./payStatus.vue?vue&type=script&lang=js&"
export * from "./payStatus.vue?vue&type=script&lang=js&"
import style0 from "./payStatus.vue?vue&type=style&index=0&id=d1c5ecda&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1c5ecda",
  null
  
)

export default component.exports